import React from 'react';
import { Flex, Box } from 'grid-styled';
import Panel from './Panel';
import Backdrop from './Backdrop';
import IconButton from './IconButton';

class PageModal extends React.Component {
    render() {
        const { close, children, header } = this.props;

        return (
            <Backdrop>
                <Panel
                    style={{
                        minWidth: 300,
                        maxWidth: '90%',
                        maxHeight: '90%'
                    }}
                >
                    <Panel.Header>
                        <Box flex="1">{header}</Box>
                        <IconButton icon="close" onClick={close} />
                    </Panel.Header>
                    <Flex
                        flexDirection="column"
                        p={2}
                        style={{ overflowY: 'auto' }}
                    >
                        {children}
                    </Flex>
                </Panel>
            </Backdrop>
        );
        /*
        return (
            <React.Fragment>
                <div className="modal-background" />
                <div role="dialog" className="modal-dialog">
                    <header>
                        <MediaQuery query="(min-device-width: 1224px)">
                            <span>{header}</span>
                        </MediaQuery>
                        <MediaQuery query="(max-device-width: 1224px)">
                            <span className="mobileHeader">{header}</span>
                        </MediaQuery>
                        {errorsPage && (
                            <img
                                onClick={close}
                                src={require('../assets/close.png')}
                                alt="edit"
                            />
                        )}
                    </header>
                    <Flex flexDirection="column" p={2}>
                        {children}
                        <Flex>
                            {!hidebuttons && (
                                <Button
                                    buttonStyle="primary"
                                    disabled={!errorsPage}
                                    onClick={close}
                                >
                                    <ButtonImage
                                        src={require('../assets/check.png')}
                                        alt="save"
                                        height="25"
                                        width="auto"
                                    />
                                    Ok
                                </Button>
                            )}
                        </Flex>
                    </Flex>

                    <div className="modal-content">
                        {children}

                        <MediaQuery query="(min-device-width: 1224px)">
                            <BoxTemplate textalign="right">

                            </BoxTemplate>
                        </MediaQuery>
                        <MediaQuery query="(max-device-width: 1224px)">
                            <Box>
                                {!hidebuttons && (
                                    <Button
                                        buttonStyle="primary"
                                        disabled={!errorsPage}
                                        onClick={close}
                                    >
                                        <ButtonImage
                                            src={require('../assets/check.png')}
                                            alt="save"
                                            height="25"
                                            width="auto"
                                        />
                                        Ok
                                    </Button>
                                )}
                            </Box>
                        </MediaQuery>
                    </div>
                    <BoxTemplate height="15px" />

                </div>
            </React.Fragment>

        );*/
    }
}

export default PageModal;



// WEBPACK FOOTER //
// ./src/uic/PageModal.js